import Popover, { PopoverContentWrapper } from '@deprecated-ui/common/Popover';
import { useDispatch } from 'react-redux';
import { effects as userEffects } from 'lib/entities/user';
import { useState } from 'react';
import { ModalBlockUser } from 'global/Moderation/Modals';
import useChat from 'hooks/useChat';
import { IconMore, OptionItem } from '../styled';
import { UserGraph } from '../../../../../@types/user';

interface ButtonMoreProps {
  username: string;
  user: UserGraph;
}

function ButtonMore({ username, user }: ButtonMoreProps) {
  const dispatch = useDispatch();
  const { openChat } = useChat();
  const [visible, setVisible] = useState(false);
  const [modalBlock, showModalBlock] = useState(false);

  /**
   * @param {Event} e
   */
  const handleSetAlert = (e) => {
    e.stopPropagation();

    const data = {
      userid: user.user_id,
      username,
    };
    // @ts-ignore
    dispatch(userEffects.setNotificationAlertUser(data));
    setVisible(false);
  };

  /**
   * @param {Event} e
   */
  // const handleToggleAddWatchlist = (e) => {
  //   e.stopPropagation();
  //   const type = user.is_followed ? 'UNFOLLOW' : 'FOLLOW';
  //   const data = {
  //     userid: user.id,
  //     username,
  //     type,
  //   };

  //   dispatch(watchlistEffects.followUser(data));
  // };

  /**
   *
   * @param {Event} e
   * @param {boolean} state
   */
  const handleShowModalBlock = (e) => {
    e.stopPropagation();
    showModalBlock(true);
    setVisible(false);
  };

  const isAlertEnabled = user?.status?.is_post_alert_enabled;

  return (
    <>
      <Popover
        trigger="click"
        placement="bottomRight"
        overlayStyle={{ minWidth: '145px' }}
        visible={visible}
        onVisibleChange={(show) => setVisible(show)}
        content={() => (
          <PopoverContentWrapper>
            <OptionItem
              onClick={() =>
                openChat({
                  username,
                  onEligible: () => setVisible(false),
                  onIneligible: () => setVisible(false),
                })
              }
            >
              Private message @{username}
            </OptionItem>
            {user?.status?.is_followed && (
              <OptionItem onClick={handleSetAlert}>
                Turn {isAlertEnabled ? 'off' : 'on'} alert for @{username} post
              </OptionItem>
            )}
            {
              // I don't know what it does
            }
            {/* <OptionItem>Post to @{username}</OptionItem> */}
            {/* <OptionItem onClick={handleToggleAddWatchlist}>
              Add or Remove from Watchlist
            </OptionItem> */}
            <OptionItem onClick={(e) => handleShowModalBlock(e)}>
              Block @{username}
            </OptionItem>
          </PopoverContentWrapper>
        )}
      >
        {/* Nedd div wrapper to prevent error forward ref */}
        <div>
          <IconMore />
        </div>
      </Popover>
      <ModalBlockUser
        visible={modalBlock}
        username={username}
        userId={user.user_id}
        onCancel={() => showModalBlock(false)}
        zIndex={1042}
      />
    </>
  );
}

export default ButtonMore;
